import { render, staticRenderFns } from "./wills.vue?vue&type=template&id=7be326da&"
import script from "./wills.vue?vue&type=script&lang=js&"
export * from "./wills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports